"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIP = VIP;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _enums = require("./enums");
/**
 * Render VIP information if required.
 * @public
 * @param {props} props passed properties to function
 * @returns {React.ReactElement|Null} The VIP component
 */
function VIP({
  details
}) {
  if (typeof details !== 'object' || !details) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "shopper-vip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "shopper-vip-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.vip
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "shopper-vip-details"
  }, /*#__PURE__*/_react.default.createElement("div", null, details.repname), /*#__PURE__*/_react.default.createElement("div", null, "Call:", /*#__PURE__*/_react.default.createElement("a", {
    href: `tel:${details.phone}`
  }, ` ${details.phone}`)), "Email:", /*#__PURE__*/_react.default.createElement("a", {
    href: `mailto:${details.email}`
  }, ` ${details.email}`)));
}
VIP.propTypes = {
  details: _propTypes.default.object
};
var _default = exports.default = VIP;